import React from "react";
import NeuroCareHeader from "../NeuroCareHeader";
const Home = () => {
    return(
        <div>
            <NeuroCareHeader/>
        </div>
    )
}
export default Home